import PropTypes from 'prop-types';
import React from 'react';

import Meeting from './Meeting';
import NewsRelease from './NewsRelease';
import Publication from './Publication';

function CMSPage({ data, type, path, loading }) {
  switch (type) {
    case 'publication':
      return <Publication data={data} loading={loading} path={path} id={data.SitePageId} />;
    case 'newsrelease':
      return <NewsRelease data={data} loading={loading} path={path} type={type} />;
    case 'meeting':
      return <Meeting data={data} loading={loading} path={path} type={type} />;
    default:
      return null;
  }
}

CMSPage.propTypes = {
  data: PropTypes.object.isRequired,
  type: PropTypes.oneOf(['meeting', 'publication', 'newsrelease']).isRequired,
  path: PropTypes.string.isRequired,
  loading: PropTypes.bool,
};

CMSPage.defaultProps = {
  loading: true,
};

export default CMSPage;
